import { Injectable, WritableSignal, signal, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, catchError, map, of } from 'rxjs';
import * as Sentry from '@sentry/browser';

import { GlobalsService } from '@services/globals.service';
import { ContactCards } from '@models/contact-cards.model';

@Injectable({
  providedIn: 'root',
})
export class ContactCardsService {
  private http = inject(HttpClient);
  private globalsService = inject(GlobalsService);
  public contactCards: WritableSignal<ContactCards | undefined> = signal(undefined);

  getData(): Observable<ContactCards> {
    if (this.contactCards() !== undefined) return of(this.contactCards() as any);
    return this.http.get<ContactCards>(`/api/contact-cards`, { headers: this.globalsService.headerHash() }).pipe(
      map((response) => {
        return response;
      }),
      catchError((e) => {
        Sentry.captureMessage('Nepodařilo se načíst kontaktní kartičky - Error: ' + e.message, { level: 'fatal' });
        return of(e);
      }),
    );
  }
}
